const types = require('../constants/actionTypes');


const initialState = {
    fundboxOpen: false,
    growthAmount: 10000.00,
    growthPeriod: 3,
    profitabilityMinYear: null,
    profitRiskOption: 0,
    selectedAssetAllocation: 0,
    selectedGlobalStock: false,
    selectedCountryExposure: false,
    selectedMarketCapitalBreakdown: 0,
    selectedTab: 0,
    subCategories: [],
    minimumDetails: [],
    loading: false,
    error: false,
};


const investmentFundViewReducer = (state = initialState, action) => {
    switch (action.type) {
        case (types.FUNDS_FETCH_REQUESTED): {
            return { loading: true, error: false };
        }
        case (types.FUNDS_FETCH_SUCCEEDED): {
            return { ...state, selectedTab: 0, loading: false, error: false };
        }
        case (types.FUNDS_FETCH_FAILED): {
            return { loading: false, error: true };
        }
        case (types.BROKER_PRODUCT_ADVANCED_SEARCH_LINK_NAME_TRACKING): {
            return { ...state, selectedTab: 0 };
        }
        case (types.ASSET_ALLOCATION_SELECTED): {
            const { index } = action.payload;
            return { ...state, selectedAssetAllocation: index };
        }
        case (types.COUNTRY_EXPOSURE_SELECTED): {
            const { id } = action.payload;
            return { ...state, selectedCountryExposure: id };
        }
        case (types.FUNDBOX_OPENED): {
            return { ...state, fundboxOpen: true };
        }
        case (types.FUNDBOX_CLOSED): {
            return { ...state, fundboxOpen: false };
        }
        case (types.GLOBAL_STOCK_SELECTED): {
            const { id } = action.payload;
            return { ...state, selectedGlobalStock: id };
        }
        case (types.GROWTH_AMOUNT_CHANGED): {
            const { amount } = action.payload;
            return { ...state, growthAmount: amount };
        }
        case (types.GROWTH_PERIOD_CHANGED): {
            const { period } = action.payload;
            return { ...state, growthPeriod: period };
        }
        case (types.MARKET_CAPITAL_BREAKDOWN_SELECTED): {
            const { index } = action.payload;
            return { ...state, selectedMarketCapitalBreakdown: index };
        }
        case (types.PROFITABILITY_RANGE_SELECTED): {
            const { minYear } = action.payload;
            return { ...state, profitabilityMinYear: minYear };
        }
        case (types.PROFIT_RISK_OPTION_SELECTED): {
            const { option } = action.payload;
            return { ...state, profitRiskOption: option };
        }
        case (types.TAB_SWITCHED): {
            const { index } = action.payload;
            return { ...state, selectedTab: index };
        }
        case (types.FUNDS_FETCH_SUB_CATEGORIES): {
            return { ...state, subCategories: action.payload }
        }
        case (types.FUNDS_FETCH_CATEGORY): {
            return { ...state, assetsCategory: action.payload }
        }
        case (types.FUNDS_FETCH_MINIMUN_DETAILS): {
            return { ...state, minimumDetails: action.payload }
        }
        case (types.FUNDS_CATALOGUE_SUCCEEDED): {
            const { fundResult } = action.payload;
            const details = !!fundResult &&
                            !!fundResult.instrumentsList &&
                            fundResult.instrumentsList[0]
            return { ...state, catalogueDetails: details }
        }
        default:
            return state;
    }
}


module.exports = investmentFundViewReducer;
